<template>
<v-container>
  <v-layout justify-center>
    <v-flex xs12 sm8 md6>
      <v-card>
        <v-list subheader>
          <v-subheader>{{ $t('settings.conversation_language') }}</v-subheader>
          <v-radio-group v-model="language">
            <v-list-tile avatar>
              <v-list-tile-action>
                <v-radio value="none"></v-radio>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('settings.specified_by_client') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile avatar>
              <v-list-tile-action>
                <v-radio value="en"></v-radio>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('settings.english') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile avatar>
              <v-list-tile-action>
                <v-radio value="de"></v-radio>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('settings.german') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-radio-group>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import {
  UserAuth
} from 'luffanet-web-components'

export default {
  name: 'Settings',
  mixins: [UserAuth],
  data: () => ({
    loading: {},
    language: undefined
  }),
  watch: {
    language(val) {
      let ref = this.$db.ref('userLang').child(this.userId);
      if (val == 'none')
        ref.remove();
      else
        ref.set(val);
    }
  },
  methods: {
    load() {
      this.$db.ref('userLang').child(this.userId).once('value').then(snapshot => {
        this.language = snapshot.val() || 'none';
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/settings.vue